import { useMemo } from "react";
import type { DomainSidebarItem } from "@/modules/navigation";
import { trpc } from "@/hooks/trpc";
import { ANALYSES } from "../analyses";

/** Methods with a fixed analysis page (biogenic amines, …) are linked there. */
const FIXED_PAGE_CODES = new Set(ANALYSES.map((a) => a.templateCode));

/** One Analytics link per active method without a fixed page, by name. */
export function useMethodNavItems(): DomainSidebarItem[] {
  const { data: templates } = trpc.tests.testTemplates.list.useQuery();
  return useMemo(
    () =>
      (templates ?? [])
        .filter((t) => t.blueprint !== null && !FIXED_PAGE_CODES.has(t.code))
        .map((t) => ({
          type: "link" as const,
          id: `method-${t.id}`,
          label: t.name,
          href: `/analytics/methods/${t.id}`,
          category: "content" as const,
        })),
    [templates],
  );
}
